

export default {
  components: {
    'id-header-category-item': () => import('~/components/header/CategoryItem.vue')
  },
  data: () => ({
    popularCategories: []
  }),
  async created () {
    const { results: popularCategories } = await this.$backend.categories.get({ popular: true })
    this.popularCategories = popularCategories
  }
}
